import { z } from "zod";

const Grade = z.object({
  id: z.string().optional(),
  label: z.string().min(1, "This field is required"),
  order: z.number().int(),
  value: z.string().min(1, "This field is required"),
});

export const GradesConfig = z.object({
  organizationId: z.string().min(1, "This field is required"),
  grades: z.array(Grade).min(1),
});

const GradeForm = z.object({
  id: z.string().optional(),
  label: z.string().min(1, "This field is required"),
  order: z
    .string()
    .min(1, "This field is required")
    .refine((value) => !Number.isNaN(parseInt(value, 10)), {
      message: "Must be a number",
    }),
  value: z.string().min(1, "This field is required"),
  userGeneratedValue: z.boolean().default(false),
});

export const GradesConfigFormSchema = z.object({
  organizationId: z.string().min(1, "This field is required"),
  grades: z.array(GradeForm).min(1),
});

export type GradesConfigType = z.infer<typeof GradesConfig>;
export type GradeType = z.infer<typeof Grade>;
export type GradesConfigFormType = z.infer<typeof GradesConfigFormSchema>;
export type GradeFormType = z.infer<typeof GradeForm>;

export function toGradesConfig(values: GradesConfigFormType): GradesConfigType {
  return {
    organizationId: values.organizationId,
    grades: values.grades.map((grade) => ({
      id: grade.id,
      label: grade.label,
      order: parseInt(grade.order, 10),
      value: grade.value,
    })),
  };
}

export function validate(gradesConfig: GradesConfigType) {
  return GradesConfig.safeParse(gradesConfig).success;
}
